import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { GET, GET_CUSTOMER_HISTORY } from '../../services';

// API คืน result.items = ประกันแต่ละใบ (ล่าสุดก่อน) พร้อม claims ของใบนั้นแนบมาให้แล้ว
// claimCount นับตามกติกาฝั่ง API (ไม่นับ CANCEL/REJECT แต่ claims[] ยังมีครบรวมที่ถูกยกเลิก)
export const useCustomerHistory = ({ customer }) => {
  const [histories, setHistories] = useState([]);
  const customerCode = customer?.customerCode || '';

  const { isPending, mutate: fetchHistories } = useMutation({
    mutationFn: async ({ expired }) => {
      const response = await GET(GET_CUSTOMER_HISTORY(customerCode, { expired }));
      return response?.result?.items || [];
    },
    onSuccess: (result) => setHistories(result),
  });

  const onFetchHistories = ({ expired }) => {
    if (!customerCode) {
      setHistories([]);
      return;
    }
    fetchHistories({ expired });
  };

  return {
    histories,
    loading: isPending,
    onFetchHistories,
  };
};
